import React from 'react';

const Heading = () => {
    return <p className="title is-1" style={{marginTop: "1em"}}>NoteTaker</p>;
}

export default Heading;